import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { setSelectedCompositionId, setSelectedProductId, setSelectedFoodcompositionId } from "store/slice/PharmaSlice";
import { setOrderType, setCompType } from "store/slice/AppSlice";
import { getCompositiontemplateInfoByTitleAPI } from "api/OmsOrdermgmtWebServices";
import { getListAPI as getProductList } from "components/product/ProductAPI";
import { getProductInfoByPartyidAPI } from "components/product/ProductAPI";
import { setSelectedCTid } from "store/slice/AppSlice";
import SelectDrugCompositionTemplate from "./SelectDrugCompositionTemplate";
import SelectFoodCompositionTemplate from "./SelectFoodCompositionTemplate";

export default function SelectCompositionTemplate({ sectionHeight }) {
  const dispatch = useDispatch();
  const { productList } = useSelector((state) => state.pharmaslice);
  const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const [ctID, setCtID] = useState(null);
  const [filter, setFilter] = useState("");
  const { orderType, compType } = useSelector((state) => state.appslice);
  const { compositiontemplateList } = useSelector((state) => state.pharmaslice);
  const [ctList, setCTList] = useState([]);
  const { userprofileInfo } = useSelector((state) => state.headerslice);
  const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard)
  
  useEffect(()=>{
    dispatch(setSelectedCompositionId(-1))
    dispatch(setSelectedFoodcompositionId(-1))
  },[])
  useEffect(()=>{
    if (productObj && productObj.comptype!==undefined){
      console.log("Product Object changed: ", productObj.comptype);
      dispatch(setCompType(productObj.comptype))
    }
  },[productObj])
  useEffect(() => {
      if (filter !== '' && filter.length > 2) {
        getCompositiontemplateInfoByTitleAPI(filter, userprofileInfo.businessid, setCTList, (data) => {});
      } else {
        setCTList([]);
      }
  }, [filter]);

  useEffect(() => {
   console.log("Composition Type changed to: ", compType);
  }, [compType]);


  const handleProductClick = (id) => {
    console.log("Selected CT ID:", id);
    setCtID(id);
    dispatch(setSelectedCTid(id));
  };


  return (

    <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
      <Grid lg={12} xs={12} item sx={{ padding: 1, backgroundColor: 'white', paddingBottom: 1, display: "flex", justifyContent: "flex-start" }}>
        <Grid container justifyContent="space-between">
          <Grid item lg={6}>
            <Typography variant="h5" sx={{ color: 'primary.darker', fontWeight: 'bold' }}>Product Composition List</Typography>
          </Grid>
          <Grid item lg={6}>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <RadioGroup
                  row
                  value={compType}
                  onChange={e => dispatch(setCompType(e.target.value))}
                  name="order-type"
                >
                  <FormControlLabel value={0} control={<Radio />} label="Drug" />
                  <FormControlLabel value={1} control={<Radio />} label="Food" />
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        
        
       </Grid>
       {compType==0?
          <SelectDrugCompositionTemplate sectionHeight={sectionHeight} />
       :  <SelectFoodCompositionTemplate sectionHeight={sectionHeight} />
       }
    </Grid>
  );
}